import React, { useEffect } from "react";

const ModalWrapper = ({ show, onClose, title, children, size = "md" }) => {
  // Prevent background scroll when modal is open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      {/* Overlay */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          zIndex: 1040,
        }}
        onClick={onClose} // close modal when overlay is clicked
      />

      {/* Modal */}
      <div
        role="dialog"
        aria-labelledby="modalTitle"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 10590,
          background: "#fff",
          borderRadius: "16px",
          padding: "1rem", // small padding all around
          width: "calc(100% - 40px)", // 20px padding left/right
          maxWidth: "800px", // optional max width for large screens
          maxHeight: "90vh", // allow vertical scrolling if content is tall
          overflowY: "auto",
          boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()} // prevent closing modal when clicking inside
      >
        {/* Header */}
        <div
          className="modal-header border-0"
          style={{ paddingBottom: "0.5rem" }}
        >
          <h5
            id="modalTitle"
            className="modal-title fw-bold text-warning"
            style={{ margin: 0 }}
          >
            {title}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          />
        </div>

        {/* Body */}
        <div className="modal-body pt-2">{children}</div>
      </div>
    </>
  );
};

export default ModalWrapper;

// <>
//       {/* Backdrop */}
//       <div className="modal-backdrop fade show"></div>

//       {/* Modal */}
//       <div
//         className="modal fade show d-block"
//         tabIndex="-1"
//         style={{
//           zIndex: 99999,
//         }}
//       >
//         <div className={`modal-dialog modal-dialog-centered modal-${size}`}>
//           <div className="modal-content rounded-4 shadow">
//             {/* Header */}
//             <div className="modal-header border-0">
//               <h5 className="modal-title fw-bold text-warning">{title}</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={onClose}
//               ></button>
//             </div>

//             {/* Body */}
//             <div className="modal-body pt-0">{children}</div>
//           </div>
//         </div>
//       </div>
//     </>
